var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOptions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.36364 10.9089H28.6364C29.3895 10.9089 30 10.2984 30 9.54528C30 8.79219 29.3895 8.18164 28.6364 8.18164H1.36364C0.610545 8.18164 0 8.79219 0 9.54528C0 10.2984 0.610545 10.9089 1.36364 10.9089ZM28.6364 13.6362H1.36364C0.610545 13.6362 0 14.2467 0 14.9998C0 15.7529 0.610545 16.3635 1.36364 16.3635H28.6364C29.3895 16.3635 30 15.7529 30 14.9998C30 14.2467 29.3895 13.6362 28.6364 13.6362ZM28.6364 19.0907H1.36364C0.610545 19.0907 0 19.7013 0 20.4544C0 21.2075 0.610545 21.818 1.36364 21.818H28.6364C29.3895 21.818 30 21.2075 30 20.4544C30 19.7013 29.3895 19.0907 28.6364 19.0907Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOptions);
export default __webpack_public_path__ + "static/media/icon-options.5965eb8b17be8cd7224a62e0c6a09f56.svg";
export { ForwardRef as ReactComponent };